import React from 'react';
import PropTypes from 'prop-types';
import DebugBox from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/DebugBox';
import OutlineBox from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/OutlineBox';
import NormalBox from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';

const Box = React.forwardRef((props, ref) => {
  const { outlined, debugColor, ...rest } = props;

  if (outlined) {
    return (
      <OutlineBox
        {...rest}
        ref={ref}
      />
    );
  }

  if (debugColor) {
    return (
      <DebugBox
        {...props}
        ref={ref}
      />
    );
  }

  return (
    <NormalBox
      {...rest}
      ref={ref}
    />
  );
});

Box.defaultProps = {
  debugColor: null,
  outlined: false,
};

Box.propTypes = {
  debugColor: PropTypes.string,
  outlined: PropTypes.bool,
};

export default Box;
